var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#0077FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3597 23.625C11.7827 23.625 8.03131 19.0267 7.875 11.375H11.1695C11.2777 16.9911 13.7065 19.37 15.6303 19.8605V11.375H18.7324V16.2186C20.6322 16.0101 22.6281 13.8029 23.3015 11.375H26.4036C26.1498 12.6342 25.6441 13.8264 24.9179 14.8772C24.1917 15.9279 23.2608 16.8146 22.1832 17.4816C23.386 18.0911 24.4484 18.9538 25.3002 20.0128C26.152 21.0717 26.774 22.3029 27.125 23.625H23.7103C23.3952 22.4767 22.7547 21.4487 21.8692 20.67C20.9837 19.8912 19.8925 19.3964 18.7324 19.2474V23.625H18.3597Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkIcon);
export default __webpack_public_path__ + "static/media/VKIcon.30060b0cb4235a9b1a97d4c7037097d4.svg";
export { ForwardRef as ReactComponent };